import React, { FC } from 'react';
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Typography,
  IconButton,
  Divider
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SocialMediaCustomerList from '../Customers/SocialMediaCustomerList';
import { ChannelTypeEnum } from 'common/enums/ChannelTypeEnum';

interface MergeCustomerModalProps {
  MargeCustomerPopup: boolean;
  handleMargeCustomerPopupClose: () => void;
  conversation: {
    customerId: number;
    channelType?: ChannelTypeEnum;
  };
}

const modalStyle: React.CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  borderRadius: 12,
  boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
  padding: '24px 28px',
  outline: 'none',
  width: '85%',
  maxWidth: 1200,
  maxHeight: '90vh',
  overflowY: 'auto',
};

const MergeCustomerModal: FC<MergeCustomerModalProps> = ({
  MargeCustomerPopup,
  handleMargeCustomerPopupClose,
  conversation,
}) => {
  const handleClose = (_event: object, reason: string) => {
    if (reason !== 'backdropClick') {
      handleMargeCustomerPopupClose();
    }
  };

  return (
    <Modal
      aria-labelledby="merge-customer-modal-title"
      aria-describedby="merge-customer-modal-description"
      open={MargeCustomerPopup}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
        style: { backgroundColor: 'rgba(0,0,0,0.4)' },
      }}
    >
      <Fade in={MargeCustomerPopup}>
        <Box style={modalStyle}>
          <IconButton
            onClick={handleMargeCustomerPopupClose}
            style={{
              position: 'absolute',
              right: 15,
              top: 15,
              color: '#666',
            }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Typography
            id="merge-customer-modal-title"
            variant="h6"
            style={{ fontWeight: 600, marginBottom: 16 }}
          >
            Connect to Existing Customer
          </Typography>

          <Divider style={{ marginBottom: 16 }} />

          <Box id="merge-customer-modal-description">
            <SocialMediaCustomerList
              sourceCrmCustomerId={conversation.customerId}
            />
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default MergeCustomerModal;
